import {
    GET_CONTACTS,
    GET_CONTACTS_SUCCESS,
    GET_CONTACTS_FAILURE,
    UPDATE_CONTACT_STATUS,
    UPDATE_CONTACT_STATUS_SUCCESS,
    UPDATE_CONTACT_STATUS_FAILURE,
    ADD_CONTACT,
    ADD_CONTACT_SUCCESS,
    ADD_CONTACT_FAILURE,
    EDIT_CONTACT,
    EDIT_CONTACT_SUCCESS,
    EDIT_CONTACT_FAILURE,
    DELETE_CONTACT,
    DELETE_CONTACT_SUCCESS,
    DELETE_CONTACT_FAILURE,
    UPDATE_CONTACT_ORDER_STATUS,
    UPDATE_CONTACT_ORDER_STATUS_SUCCESS,
    UPDATE_CONTACT_ORDER_STATUS_FAILURE,
} from "../Constants"

export const GetContacts = (payload) => ({
    type: GET_CONTACTS,
    payload
});

export const GetContactsSuccess = (payload) => ({
    type: GET_CONTACTS_SUCCESS,
    payload
});

export const GetContactsFailure = (payload) => ({
    type: GET_CONTACTS_FAILURE,
    payload
});

export const UpdateContactStatus = (payload) => ({
    type: UPDATE_CONTACT_STATUS,
    payload
});

export const UpdateContactStatusSuccess = (payload) => ({
    type: UPDATE_CONTACT_STATUS_SUCCESS,
    payload
});

export const UpdateContactStatusFailure = (payload) => ({
    type: UPDATE_CONTACT_STATUS_FAILURE,
    payload
});

export const AddContact = (payload) => ({
    type: ADD_CONTACT,
    payload
});

export const AddContactSuccess = (payload) => ({
    type: ADD_CONTACT_SUCCESS,
    payload
});

export const AddContactFailure = (payload) => ({
    type: ADD_CONTACT_FAILURE,
    payload
});

export const EditContact = (payload) => ({
    type: EDIT_CONTACT,
    payload
});

export const EditContactSuccess = (payload) => ({
    type: EDIT_CONTACT_SUCCESS,
    payload
});

export const EditContactFailure = (payload) => ({
    type: EDIT_CONTACT_FAILURE,
    payload
});

export const DeleteContact = (payload) => ({
    type: DELETE_CONTACT,
    payload
});

export const DeleteContactSuccess = (payload) => ({
    type: DELETE_CONTACT_SUCCESS,
    payload
});

export const DeleteContactFailure = (payload) => ({
    type: DELETE_CONTACT_FAILURE,
    payload
});

export const UpdateContactOrderStatus = (payload) => ({
    type: UPDATE_CONTACT_ORDER_STATUS,
    payload
});

export const UpdateContactOrderStatusSuccess = (payload) => ({
    type: UPDATE_CONTACT_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateContactOrderStatusFailure = (payload) => ({
    type: UPDATE_CONTACT_ORDER_STATUS_FAILURE,
    payload
});